<template>
    <span>
        <h2>{{ this.headerTitle }}</h2>
    </span>
</template>

<script>
export default {
    name: 'region-header',
    props: {
        defaultGeo: {
            type: String,
            required: true,
        },
        defaultRegion: {
            type: String,
            required: true,
        },
        regionData: {
            type: Object,
            required: true,
        },
        headerText: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            geo: this.defaultGeo.toLowerCase(),
            region: this.defaultRegion.toLowerCase(),
            headerTitle: '',
        };
    },
    mounted: function() {
        if ($cookies.isKey(('op_list_region_' + this.geo))) {
            this.region = $cookies.get(('op_list_region_' + this.geo)).toLowerCase()
        }

        this.updateHeader();
    },
    methods: {
        updateHeader() {
            this.headerTitle = this.headerText.replace('{region}', this.getRegionName());
        },
        getRegionName() {
            let upperGeo = this.geo.toUpperCase();
            let upperRegion = this.region.toUpperCase();

            return this.regionData[upperGeo].supported_regions.find(regionEntry => regionEntry.code === upperRegion).name;
        },
    }
};
</script>
